import React from "react";

export const HtmlOrTextContent = ({ content = "" }: { content: string }) => {
  const regex = new RegExp(/(<([^>]+)>)/i);
  const isHtml = regex.test(content);
  if (isHtml) {
    return <span dangerouslySetInnerHTML={{ __html: content }}></span>;
  }
  return <>{content}</>;
};
